import React from 'react';
import {
	Table,
	TableHead,
	TableHeadRow,
	TableHeadCell,
	TableBody,
	TableRow,
	TableCell,
} from './table';
import { club_data_stats } from '../lib/historicalData';

export default function ClubStatsTable() {
	return (
		<div className="overflow-x-auto">
			<Table className="table-auto overflow-scroll w-full">
				<TableHead>
					<TableHeadRow>
						<TableHeadCell>Club</TableHeadCell>
						<TableHeadCell>
							Aantal jaren in de divisie
						</TableHeadCell>
					</TableHeadRow>
				</TableHead>
				<TableBody className="bg-white divide-y divide-gray-200">
					{club_data_stats.map((seizoen, i) => (
						<TableRow key={i} striped>
							<TableCell>{seizoen.Club}</TableCell>
							<TableCell>{seizoen.jaren}</TableCell>
						</TableRow>
					))}
				</TableBody>
			</Table>
		</div>
	);
}
